import {
  IconButton as MuiIconButton,
  Stack,
  type StackProps,
} from '@mui/material';

import Clear from 'shared/icons/Clear';

import styled from 'shared/utils/styled';

export namespace Styled {
  export const List = styled((props: StackProps) => (
    <Stack component="ul" spacing={0.75} {...props} />
  ))(() => ({
    width: '100%',
    margin: 0,
    padding: 0,
    listStyle: 'none',
  }));

  export const ListItem = styled('li')(() => ({
    display: 'flex',
    alignItems: 'center',
  }));

  export const TextOverflow = styled('span')(() => ({
    flex: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'pre-wrap',
  }));

  export const FileName = styled('span')(({ theme }) => ({
    fontSize: theme.typography.pxToRem(14),
  }));

  export const FileMetadata = styled('span')(({ theme }) => ({
    fontSize: theme.typography.pxToRem(13),
  }));

  export const IconButton = styled(MuiIconButton)(() => ({
    padding: 2,
    background: 'rgb(240, 243, 247)',
  }));

  export const ClearIcon = styled(Clear)(({ theme }) => ({
    fontSize: theme.typography.pxToRem(18),
  }));

  export const Centered = styled('div')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    flex: 1,
  });
}
